import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const selectedNumbersSlice = createSlice({
  name: 'selectedNumbers',
  initialState: [1, 2, 3, 4, 5] as number[],
  reducers: {
    updateSelectedNumbers: (state, action: PayloadAction<number[]>) => {
      state.splice(0, state.length, ...action.payload);
    },
  },
});
export const { updateSelectedNumbers } = selectedNumbersSlice.actions;
export default selectedNumbersSlice.reducer;
